import {
  archiveProductApiRequest,
  changeProductActivityApiRequest,
  createGroupApiRequest,
  createProductApiRequest,
  createProductSectionApiRequest,
  createProductVideoApiRequest,
  deleteProductGroupApiRequest,
  deleteVideoApiRequest,
  editProductApiRequest,
  editProductGroupApiRequest,
  editSectionApiRequest,
  editVideoApiRequest,
  getAllArchivedProductsApiRequest,
  getAllProductsApiRequest,
  getAllSectionsApiRequest,
  getAllVideosApiRequest,
  getGroupsForProductsApiRequest,
  getVideosByProductIdApiRequest,
  previewFileApiRequest,
  restoreProductApiRequest,
  uploadFileToS3,
} from '@guryou/api-client';
import { getPublicVideosApiCall } from '@guryou/api-client-gql';

import { executeApiCall } from '../core';
import {
  ARCHIVED_PRODUCTS,
  PRODUCT_ARCHIVE,
  PRODUCT_CREATE,
  PRODUCT_FILE_PREVIEW,
  PRODUCT_GROUP_CREATE,
  PRODUCT_GROUP_DELETE,
  PRODUCT_GROUP_UPDATE,
  PRODUCT_GROUPS_GET,
  PRODUCT_S3,
  PRODUCT_SECTION_CREATE,
  PRODUCT_SECTION_UPDATE,
  PRODUCT_STATUS_UPDATE,
  PRODUCT_UPDATE,
  PRODUCT_VIDEO_CREATE,
  PRODUCT_VIDEO_DELETE,
  PRODUCT_VIDEO_UPDATE,
  PRODUCT_VIDEOS_GET_MANY,
  PRODUCTS_GET_MANY,
  PRODUCTS_SECTIONS_GET_MANY,
  RESTORE_PRODUCT,
  SECTION_VIDEOS_GET,
} from '../types';

import { execute } from './actionWrapper';

const twoUndefined = [undefined, undefined];

// EXECUTEAPICALL - ARGUMENTS - (function-apiRequest, action, silent, customMessage, noMessage)

const createGroup = data => async dispatch => dispatch(executeApiCall(createGroupApiRequest(data), PRODUCT_GROUP_CREATE));

const editProductGroup = (id, data) => async dispatch => dispatch(executeApiCall(editProductGroupApiRequest(id, data), PRODUCT_GROUP_UPDATE));

const deleteProductGroup = id => async dispatch => dispatch(executeApiCall(deleteProductGroupApiRequest(id), PRODUCT_GROUP_DELETE));

const getGroupsForProducts = silent => async dispatch =>
  dispatch(executeApiCall(getGroupsForProductsApiRequest(), PRODUCT_GROUPS_GET, silent, undefined, true));

const getAllProducts = silent => async dispatch => dispatch(executeApiCall(getAllProductsApiRequest(), PRODUCTS_GET_MANY, silent, undefined, true));

const getAllSectionsById = (id, silent) => async dispatch =>
  dispatch(executeApiCall(getAllSectionsApiRequest(id), PRODUCTS_SECTIONS_GET_MANY, silent));

const getAllVideosById = (id, silent, customMessage) => async dispatch =>
  dispatch(executeApiCall(getAllVideosApiRequest(id), SECTION_VIDEOS_GET, silent, undefined, customMessage));

const createProduct = data => async dispatch => dispatch(executeApiCall(createProductApiRequest(data), PRODUCT_CREATE));

const archiveProduct = (id, changeStatus) => async dispatch => dispatch(executeApiCall(archiveProductApiRequest(id, changeStatus), PRODUCT_ARCHIVE));

const editProduct = (data, id) => async dispatch => dispatch(executeApiCall(editProductApiRequest(data, id), PRODUCT_UPDATE));

const editSection = (data, productId, sectionId) => async dispatch =>
  dispatch(executeApiCall(editSectionApiRequest(data, productId, sectionId), PRODUCT_SECTION_UPDATE));

const createProductVideo = (id, data) => async dispatch =>
  dispatch(executeApiCall(createProductVideoApiRequest(id, data), PRODUCT_VIDEO_CREATE, ...twoUndefined, true));

const createProductSection = (id, data) => async dispatch =>
  dispatch(executeApiCall(createProductSectionApiRequest(id, data), PRODUCT_SECTION_CREATE));

const upploadToS3 = (id, name, files, presignedUrl) => async dispatch =>
  dispatch(executeApiCall(uploadFileToS3(id, name, files, presignedUrl), PRODUCT_S3));

const changeProductActivity = id => async dispatch => dispatch(executeApiCall(changeProductActivityApiRequest(id), PRODUCT_STATUS_UPDATE));

const deleteVideo = (productId, fileId, sectionIndex) => async dispatch =>
  dispatch(executeApiCall(deleteVideoApiRequest(productId, fileId, sectionIndex), PRODUCT_VIDEO_DELETE));

const editVideo = (productId, fileId, data) => async dispatch =>
  dispatch(executeApiCall(editVideoApiRequest(productId, fileId, data), PRODUCT_VIDEO_UPDATE));

const previewFile =
  (productId, fileId, isPublic = false) =>
  async dispatch =>
    dispatch(executeApiCall(previewFileApiRequest(productId, fileId, isPublic), PRODUCT_FILE_PREVIEW));

const getArchivedProducts = silent => async dispatch =>
  dispatch(executeApiCall(getAllArchivedProductsApiRequest(), ARCHIVED_PRODUCTS, silent, undefined, true));

const restoreProduct = id => async dispatch => dispatch(executeApiCall(restoreProductApiRequest(id), RESTORE_PRODUCT));

const getVideosByProductId = (id, customMessage) => async dispatch =>
  dispatch(executeApiCall(getVideosByProductIdApiRequest(id), PRODUCT_VIDEOS_GET_MANY, undefined, customMessage));

const getAllPublicProducts = (providerId, keyword, webIntegrationId) => async dispatch =>
  execute(dispatch, () => getPublicVideosApiCall({ providerId, keyword, webIntegrationId }), PRODUCT_VIDEOS_GET_MANY, false);

export {
  archiveProduct,
  changeProductActivity,
  createGroup,
  createProduct,
  createProductSection,
  createProductVideo,
  deleteProductGroup,
  deleteVideo,
  editProduct,
  editProductGroup,
  editSection,
  editVideo,
  getAllProducts,
  getAllPublicProducts,
  getAllSectionsById,
  getAllVideosById,
  getArchivedProducts,
  getGroupsForProducts,
  getVideosByProductId,
  previewFile,
  restoreProduct,
  upploadToS3,
};
